module.exports = "https://deal-img.imgix.net/consumer/modern/miami.cc432e0c.jpg";